module.exports = __webpack_public_path__ + "img/mugshot_GOLDFISH.png";